/* TÊTE FROIDE — comportements du thème (sans dépendance).
   Apparitions au défilement, recherche, menu mobile, ancres, tiroir panier AJAX (Section Rendering API),
   fiche produit (coloris → variante + galerie filtrée), filtre couleur et tri des collections. */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var TF = w.TF || {};
  var DESIGN = !!(w.Shopify && w.Shopify.designMode);
  var REDUCE = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('js');

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ---------- prix (même rendu que le filtre Liquid money) ---------- */
  function formatMoney(cents) {
    var fmt = TF.moneyFormat || '{{amount_with_comma_separator}} €';
    cents = parseInt(cents, 10) || 0;
    function delim(n, prec, th, dec) {
      var v = (n / 100).toFixed(prec), p = v.split('.');
      var i = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return p[1] ? i + dec + p[1] : i;
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', val;
    switch (key) {
      case 'amount_no_decimals': val = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = delim(cents, 2, ' ', ','); break;
      default: val = delim(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }

  /* ---------- message ---------- */
  var tt;
  function toast(msg) {
    var el = $('.tf-toast'); if (!el) return;
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(tt); tt = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------- apparitions (maquette : seuil 0.08, marge basse -40px) ---------- */
  var io = null;
  function revealAll(scope) {
    var els = $$('[data-reveal]:not(.is-in)', scope);
    if (REDUCE || DESIGN || !('IntersectionObserver' in w)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- menu, recherche ---------- */
  function openMenu() { closeCart(); d.body.classList.add('menu-open'); var m = $('#tf-menu'); if (m) m.setAttribute('aria-hidden', 'false'); }
  function closeMenu() { d.body.classList.remove('menu-open'); var m = $('#tf-menu'); if (m) m.setAttribute('aria-hidden', 'true'); }
  function toggleSearch(force) {
    var on = typeof force === 'boolean' ? force : !d.body.classList.contains('search-open');
    d.body.classList.toggle('search-open', on);
    var inp = $('[data-search-input]');
    if (inp) { inp.value = ''; filterSearch(''); if (on) setTimeout(function () { inp.focus(); }, 30); }
  }
  function filterSearch(q) {
    q = (q || '').trim().toLowerCase();
    var n = 0;
    $$('[data-search-item]').forEach(function (a) {
      var ok = q ? a.getAttribute('data-search-item').indexOf(q) > -1 : n < 4;
      if (ok) { a.removeAttribute('hidden'); n++; } else a.setAttribute('hidden', '');
    });
  }
  d.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-search-input]')) filterSearch(e.target.value); });

  /* ---------- ancres vers l'accueil (Collections, Notre histoire) ---------- */
  function scrollToId(id) {
    var el = d.getElementById(id); if (!el) return false;
    w.scrollTo({ top: el.getBoundingClientRect().top + w.scrollY - 60, behavior: REDUCE ? 'auto' : 'smooth' });
    return true;
  }

  /* ---------- panier ---------- */
  var SECTION = 'tf-cart-drawer';
  function openCart() {
    closeMenu(); toggleSearch(false);
    d.body.classList.add('cart-open');
    var dr = $('#tf-drawer'); if (dr) setTimeout(function () { try { dr.focus({ preventScroll: true }); } catch (e) {} }, 50);
  }
  function closeCart() { d.body.classList.remove('cart-open'); }
  function setCount(n) {
    $$('[data-cart-badge]').forEach(function (b) { b.textContent = n; b.classList.toggle('is-full', n > 0); });
  }
  function renderDrawer(html) {
    var wrap = $('#shopify-section-' + SECTION); if (!wrap || !html) return;
    var tmp = d.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-' + SECTION) || tmp;
    wrap.innerHTML = fresh.innerHTML;
    var dr = $('#tf-drawer'); if (dr) setCount(parseInt(dr.getAttribute('data-cart-count'), 10) || 0);
  }
  function post(url, body) {
    return w.fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function addToCart(id, qty, btns) {
    (btns || []).forEach(function (b) { b.disabled = true; });
    return post((TF.routes && TF.routes.cartAdd || '/cart/add') + '.js', { items: [{ id: parseInt(id, 10), quantity: qty || 1 }], sections: SECTION, sections_url: w.location.pathname })
      .then(function (res) { renderDrawer(res.sections && res.sections[SECTION]); openCart(); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Impossible d’ajouter ce produit.'); })
      .then(function () { (btns || []).forEach(function (b) { b.disabled = false; }); });
  }
  function changeLine(key, qty) {
    var dr = $('#tf-drawer'); if (dr) dr.classList.add('is-busy');
    return post((TF.routes && TF.routes.cartChange || '/cart/change') + '.js', { id: key, quantity: qty, sections: SECTION, sections_url: w.location.pathname })
      .then(function (res) { renderDrawer(res.sections && res.sections[SECTION]); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Erreur panier.'); var x = $('#tf-drawer'); if (x) x.classList.remove('is-busy'); });
  }

  /* ---------- clics délégués ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-menu-open]'))) { e.preventDefault(); openMenu(); return; }
    if ((el = t.closest('[data-search-toggle]'))) { e.preventDefault(); toggleSearch(); return; }
    if ((el = t.closest('[data-cart-open]'))) { if ($('#tf-drawer')) { e.preventDefault(); openCart(); } return; }
    if ((el = t.closest('[data-cart-close], [data-menu-close]'))) { e.preventDefault(); closeCart(); closeMenu(); return; }
    if ((el = t.closest('[data-line-set]'))) {
      var line = el.closest('[data-line-key]'); if (!line) return;
      e.preventDefault(); changeLine(line.getAttribute('data-line-key'), Math.max(0, parseInt(el.getAttribute('data-line-set'), 10) || 0)); return;
    }
    if ((el = t.closest('[data-quick-add]'))) { e.preventDefault(); e.stopPropagation(); addToCart(el.getAttribute('data-quick-add'), 1, [el]); return; }
    if ((el = t.closest('[data-anchor]'))) {
      var id = el.getAttribute('data-anchor');
      closeMenu(); toggleSearch(false);
      if (d.getElementById(id)) { e.preventDefault(); scrollToId(id); }
      return;
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); toggleSearch(false); } });

  /* ---------- fiche produit ---------- */
  var VIEW_NAMES = ['FACE', 'PROFIL', 'ARRIÈRE', 'BRODERIE', 'PORTÉE'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initProduct(rootEl) {
    if (!rootEl || rootEl.__tf) return; rootEl.__tf = true;
    var json = $('[data-product-json]', rootEl); if (!json) return;
    var data; try { data = JSON.parse(json.textContent); } catch (e) { return; }
    var ci = data.colourIndex;
    var idInput = $('[data-variant-id]', rootEl);
    var form = $('[data-product-form]', rootEl);
    var views = $$('[data-view]', rootEl), thumbs = $$('[data-thumb]', rootEl), counter = $('[data-view-counter]', rootEl);
    var current = null, visible = [], idx = 0;
    data.variants.forEach(function (v) { if (idInput && String(v.id) === idInput.value) current = v; });
    if (!current) current = data.variants[0];
    var sel = current ? current.options.slice() : [];
    var colour = ci >= 0 ? sel[ci] : null;

    /* variante exacte pour la sélection ; sinon la meilleure du coloris choisi */
    function findVariant() {
      if (ci >= 0) sel[ci] = colour;
      var exact = null, best = null;
      data.variants.forEach(function (v) {
        if (v.options.every(function (o, i) { return o === sel[i]; })) exact = v;
        if (ci < 0 || v.options[ci] === colour) { if (!best || (!best.available && v.available)) best = v; }
      });
      var v = exact || best;
      if (v) sel = v.options.slice();
      return v;
    }
    function setText(sel, txt) { $$(sel, rootEl).forEach(function (n) { n.textContent = txt; }); }
    function show(i) {
      idx = Math.max(0, Math.min(i, visible.length - 1));
      views.forEach(function (v) { v.classList.remove('is-on'); });
      thumbs.forEach(function (b) { b.classList.remove('is-on'); });
      var cur = visible[idx]; if (!cur) return;
      views[cur.i].classList.add('is-on');
      if (thumbs[cur.i]) thumbs[cur.i].classList.add('is-on');
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(visible.length) + ' — ' + cur.label;
    }
    function filterGallery() {
      if (!views.length) return;
      var key = (colour || '').toLowerCase();
      visible = [];
      views.forEach(function (v, i) {
        var mc = v.getAttribute('data-media-colour');
        if (!mc || ci < 0 || mc === key) visible.push({ i: i });
      });
      if (!visible.length) views.forEach(function (v, i) { visible.push({ i: i }); });
      visible.forEach(function (o, n) { o.label = views[o.i].getAttribute('data-view-label') || VIEW_NAMES[n] || ('VUE ' + (n + 1)); });
      var on = {}; visible.forEach(function (o) { on[o.i] = true; });
      thumbs.forEach(function (b, i) {
        if (on[i]) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
        var o = null; visible.forEach(function (x) { if (x.i === i) o = x; });
        var l = $('.tf-thumb__l', b); if (l && o) l.textContent = o.label;
      });
      var wrap = $('[data-thumbs]', rootEl); if (wrap) { if (visible.length > 1) wrap.removeAttribute('hidden'); else wrap.setAttribute('hidden', ''); }
      show(0);
    }
    function update(push) {
      var v = findVariant(); current = v;
      $$('.tf-size', rootEl).forEach(function (b) {
        var oi = parseInt(b.getAttribute('data-opt-index'), 10), val = b.getAttribute('data-value');
        b.setAttribute('aria-pressed', sel[oi] === val ? 'true' : 'false');
        b.classList.toggle('is-na', !data.variants.some(function (x) { return x.options[oi] === val && (ci < 0 || x.options[ci] === colour) && x.available; }));
      });
      $$('[data-opt-name]', rootEl).forEach(function (n) { var oi = parseInt(n.getAttribute('data-opt-name'), 10); if (sel[oi]) n.textContent = sel[oi].toUpperCase(); });
      if (ci >= 0 && colour) setText('[data-colour-name]', colour.toUpperCase());
      $$('.tf-sw', rootEl).forEach(function (b) {
        var c = b.getAttribute('data-colour');
        b.setAttribute('aria-pressed', c === colour ? 'true' : 'false');
        b.classList.toggle('is-na', !data.variants.some(function (x) { return x.options[ci] === c && x.available; }));
      });
      var atc = $('[data-atc]', rootEl), label = $('[data-atc-label]', rootEl), proxy = $('[data-atc-proxy]', rootEl);
      if (v) {
        if (idInput) idInput.value = v.id;
        setText('[data-price]', formatMoney(v.price));
        if (atc) atc.disabled = !v.available;
        if (proxy) proxy.disabled = !v.available;
        if (label) label.textContent = v.available ? 'AJOUTER AU PANIER — ' + formatMoney(v.price) : 'ÉPUISÉ';
        if (push && w.history && w.history.replaceState) {
          var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState({}, '', u.toString());
        }
      }
      filterGallery();
    }
    rootEl.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('.tf-sw'))) { colour = b.getAttribute('data-colour'); update(true); return; }
      if ((b = e.target.closest('.tf-size'))) { sel[parseInt(b.getAttribute('data-opt-index'), 10)] = b.getAttribute('data-value'); update(true); return; }
      if ((b = e.target.closest('[data-thumb]'))) {
        var i = parseInt(b.getAttribute('data-thumb'), 10), n = 0;
        visible.forEach(function (o, k) { if (o.i === i) n = k; });
        show(n); return;
      }
      if ((b = e.target.closest('[data-size-toggle]'))) { var s = $('[data-size-info]', rootEl); if (s) { if (s.hasAttribute('hidden')) s.removeAttribute('hidden'); else s.setAttribute('hidden', ''); } return; }
      if ((b = e.target.closest('[data-acc-btn]'))) {
        var item = b.closest('[data-acc]'), open = !item.classList.contains('is-open');
        $$('[data-acc]', rootEl).forEach(function (x) {
          var on = x === item && open;
          x.classList.toggle('is-open', on);
          var bb = $('[data-acc-btn]', x); if (bb) bb.setAttribute('aria-expanded', on ? 'true' : 'false');
          var sg = $('[data-sign]', x); if (sg) sg.textContent = on ? '−' : '+';
        });
        return;
      }
      if ((b = e.target.closest('[data-atc-proxy]'))) {
        if (current && current.available) addToCart(current.id, 1, [b]);
      }
    });
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!$('#tf-drawer')) return;
        e.preventDefault();
        if (!current || !current.available) return;
        addToCart(current.id, 1, $$('[data-atc]', rootEl));
      });
    }
    update(false);
  }

  /* ---------- collection : couleur + tri, avec les squelettes de la maquette (420 ms) ---------- */
  function initCollection(sec) {
    if (!sec || sec.__tf) return; sec.__tf = true;
    var grid = $('[data-filter-grid]', sec); if (!grid) return;
    var count = $('[data-count]', sec), empty = $('[data-empty]', sec), sortSel = $('[data-sort]', sec);
    var cards = $$('[data-card]', grid);
    cards.forEach(function (c, i) { c.__order = i; });
    var state = { colour: null, label: '', sort: 'new' };
    var lt;
    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var cols = '|' + (c.getAttribute('data-colours') || '') + '|';
        var ok = !state.colour || cols.indexOf('|' + state.colour + '|') > -1;
        if (ok) { c.removeAttribute('hidden'); n++; } else c.setAttribute('hidden', '');
      });
      var sorted = cards.slice().sort(function (a, b) {
        if (state.sort === 'asc') return a.getAttribute('data-price') - b.getAttribute('data-price');
        if (state.sort === 'desc') return b.getAttribute('data-price') - a.getAttribute('data-price');
        return a.__order - b.__order;
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
      if (count) count.textContent = n + (n > 1 ? ' MODÈLES' : ' MODÈLE') + (state.colour ? ' · ' + state.label : '');
      if (empty) { if (n === 0) empty.removeAttribute('hidden'); else empty.setAttribute('hidden', ''); }
    }
    function run() {
      sec.classList.add('is-loading');
      clearTimeout(lt);
      lt = setTimeout(function () { apply(); sec.classList.remove('is-loading'); }, REDUCE ? 0 : 420);
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-colour-filter]');
      if (b) {
        var k = b.getAttribute('data-colour-filter');
        state.colour = state.colour === k ? null : k;
        state.label = b.getAttribute('data-colour-label') || '';
        $$('[data-colour-filter]', sec).forEach(function (x) { var on = x.getAttribute('data-colour-filter') === state.colour; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        run(); return;
      }
      var r = e.target.closest('[data-filter-reset]');
      if (r && state.colour) { e.preventDefault(); state.colour = null; $$('[data-colour-filter]', sec).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); }); run(); }
    });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; run(); });
  }

  /* ---------- init ---------- */
  function init(scope) {
    revealAll(scope);
    $$('[data-pdp]', scope).forEach(initProduct);
    $$('[data-collection]', scope).forEach(initCollection);
  }
  init(d);
  if (w.location.hash && /^#tf-/.test(w.location.hash)) setTimeout(function () { scrollToId(w.location.hash.slice(1)); }, 150);

  /* éditeur de thème */
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  d.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector('#tf-drawer')) openCart(); });
  d.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector('#tf-drawer')) closeCart(); });
})();
